/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:cfd24081-2413-4cd8-8bea-2ffd537a69ab",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_wkJmnKhv7",
    "aws_user_pools_web_client_id": "4p452kopalfe1jmasc772lc4rf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://gdhsvgirifgllaquchzbzw5gwe.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-kolb6ontivfgnahp7fz2hq5s6q",
    "aws_user_files_s3_bucket": "rnbr-storage-d130ee40161822-staging",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
